import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDoubleWin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M8.99 7.5A5.989 5.989 0 0 0 7 7.841a6 6 0 1 0 7 8.976l1.25.83A7.5 7.5 0 1 1 9.416 6.012L9.354 7.51 8.99 7.5Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M15 4.5a6 6 0 0 0-6 6 .75.75 0 0 1-1.5 0 7.5 7.5 0 1 1 3.679 6.455.75.75 0 1 1 .765-1.29A6 6 0 1 0 15 4.5Z"
    />
    <path
      fill="#F7A600"
      d="m17.064 8.618-3.258-.873a.75.75 0 0 0-.388 1.448l1.51.405-8.175 4.72a.75.75 0 1 0 .75 1.3l8.176-4.72-.405 1.51a.75.75 0 1 0 1.449.389l.873-3.259v-.001a.746.746 0 0 0-.53-.919h-.002Z"
    />
  </svg>
);
export default SvgTwoColorDoubleWin;
